{
  "priceListForm": [],
  "priceTypes": [],
  "variantCombination": [],
  "variantCombinationSortExpression":null,
  "variantCombinationPaging": {
    "offset": 20,
    "page": 1
  }
}